import { render, staticRenderFns } from "./CreatePayrollDetailsModal.vue?vue&type=template&id=a0c7e386&scoped=true&"
import script from "./CreatePayrollDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePayrollDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c7e386",
  null
  
)

export default component.exports